export enum PriorityIconUrls {
    Lowest = '../Content/xpress-app/images/home-disciplinary-icons/chevron-lowest.svg',
    Low = '../Content/xpress-app/images/home-disciplinary-icons/chevron-low.svg',
    Medium = '../Content/xpress-app/images/home-disciplinary-icons/chevron-medium.svg',
    High = '../Content/xpress-app/images/home-disciplinary-icons/chevron-high.svg',
    Highest = '../Content/xpress-app/images/home-disciplinary-icons/chevron-highest.svg'
}
